import MaterialTableTS from "components/tables/MaterialTableTS";
import useGetExecutionHistoryByJobId from "../hooks/useGetExecutionHistoryByJobId";

const ExecutionDetailsTable = ({ jobConfigId }) => {
  const { data: executionDetails, isLoading } = useGetExecutionHistoryByJobId(
    jobConfigId ?? 0
  );

  const columns = [
    {
      title: "Status",
      field: "status",
    },
    {
      title: "Executed By",
      field: "executedBy",
    },
    {
      title: "Execution Date",
      field: "executionDate",
      render: (rowData) => {
        return (
          rowData.executionDate &&
          new Date(rowData.executionDate).toLocaleString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        );
      },
    },
  ];

  return (
    <>
      <div className="w-full p-2 bg-white">
        <div className="overflow-x-auto grid grid-row">
          <MaterialTableTS
            columns={columns}
            data={executionDetails}
            isLoading={isLoading}
            selection={false}
            showTitle={false}
            exportButton={false}
            grouping={undefined}
            detailPanel={undefined}
            selectedRows={[]}
            onSelectionChange={undefined}
            paging={true}
            searchFieldAlignment={undefined}
            toolBarComponent={undefined}
            tableRef={undefined}
            onSearchChange={undefined}
            title={undefined}
          />
        </div>
      </div>
    </>
  );
};

export default ExecutionDetailsTable;
